module.exports = __webpack_public_path__ + "media/images/emblems/Bruenisried-coat_of_arms-10f127240cb1b0653d4bef1698a0f6d9.svg";